import RequestsIndex from '@/views/RequestsIndex.vue';

const routes = [
    {
        path: '/requests',
        name: 'RequestsIndex',
        component: RequestsIndex,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
